import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import Icon from 'components/Icon';
import { breakpoints } from 'js/breakpoints';
import fallbackImageSrc from '../../assets/image-placeholder-light.svg';

const ExternalSiteLinkCard = ({
  intro,
  image,
  heading,
  linkText,
  headingTagLevel = 3,
}) => {
  const HeadingTag = `h${headingTagLevel}`;
  const fallbackImage = {
    src: fallbackImageSrc,
  };

  return (
    <article className="external-site-link-block">
      <div className="content">
        <header>
          <HeadingTag>{heading}</HeadingTag>
          {intro && (
            <div
              className="text typo-small"
              dangerouslySetInnerHTML={{
                __html: intro,
              }}
            />
          )}
        </header>
        {linkText && (
          <span className="typo-small">
            {linkText}
            <Icon use="external" />
          </span>
        )}
      </div>
      <div className="image">
        <ResponsiveImage
          {...(image ?? fallbackImage)}
          fluid
          loading="lazy"
          sources={[
            {
              width: 100,
              height: 100,
              media: breakpoints.m,
            },
            {
              width: 330,
              height: 290,
              media: breakpoints.l,
            },
          ]}
        />
      </div>
    </article>
  );
};

ExternalSiteLinkCard.propTypes = {
  image: PropTypes.exact(ResponsiveImage.propTypes),
  intro: PropTypes.string,
  heading: PropTypes.string,
  linkText: PropTypes.string,
  headingTagLevel: PropTypes.oneOf([2, 3]),
};

export default ExternalSiteLinkCard;
